module.exports = __webpack_public_path__ + "img/stop_btn.ce40c340.png";